const DELETE_BASE_KEY = 'assetActionsLibForms.modals.delete';
export function getDeleteLangKey(formType, suffix) {
  const typeKey = formType === 'CAPTURED' ? 'collectedFormDeletionDialog' : 'deletionDialog';
  return `${DELETE_BASE_KEY}.${typeKey}.${suffix}`;
}